<hr />
<div class="row my-2">
  <div class="col-sm-4">
    <h6>
      <img
        class="p-2"
        ngSrc="assets/images/icons/envasado.svg"
        alt="Vehículos"
        height="50"
        width="50"
      />
      {{ entityName }}
    </h6>
  </div>
  <div class="col-sm-8 text-end">
    <div class="input-search-container-new">
      <span class="material-symbols-outlined search-icon"> search </span>
      <input
        placeholder="Buscar"
        class="input-search-datatable"
        id="custom-search-input"
        type="text"
        [(ngModel)]="searchText"
        (input)="applyFilter()"
      />
    </div>
    <button
      id="envasados-list-new"
      class="btn-btn-create"
      (click)="onNewEnvasado()"
      *ngIf="showButton('create')"
    >
      Crear {{ entityName }}
    </button>
    <button
      id="envasados-list-refresh"
      class="btn btn-light mx-2 btn-refresh"
      (click)="onRefresh()"
    >
      <span class="material-symbols-outlined"> refresh </span>
    </button>
  </div>
</div>
<div class="row">
  <div class="text-center my-5" *ngIf="isGettingEnvasados">
    <app-spinner message="Cargando {{ entityName }}"></app-spinner>
  </div>
  <div class="col-xs-12">
    <div class="table-responsive-sm" *ngIf="!isGettingEnvasados">
      <table
        datatable
        [dtOptions]="dtOptions"
        class="table display nowrap"
        style="width: 100%"
      >
        <caption>
          Lista de Vehículos
        </caption>
        <thead>
          <tr class="text-center">
            <th
              scope="col"
              *ngFor="let attribute of envasadosAttributes"
              [hidden]="hideColumn(attribute)"
            >
              {{ attribute }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let envasado of envasados">
            <td>
              <a
                id="envasados-list-{{ envasado.licensePlate }}"
                (click)="onSelectedEnvasado(envasado)"
                style="color: #0d6efd"
                >{{ envasado.sapId! | sapId }}</a
              >
            </td>
            <td>
              <span>
                <img
                  [ngSrc]="getImageSrc(envasado.status)"
                  height="25"
                  width="25"
                  alt="Estado"
                />
              </span>
              {{ envasado.status | master : "VEHICLES#STATUSES" }}
            </td>
            <td>{{ envasado.licensePlate }}</td>
            <td [hidden]="hideColumn('Transportista')">
              {{ envasado.carrier!.name }}
            </td>
            <td>{{ envasado.center | master : "CENTERS" }}</td>
            <td>
              <span
                class="badge border rounded-4 text-bg-light mx-1"
                *ngIf="hasToExpireDocuments(envasado)"
              >
                <span class="badge border rounded-circle text-bg-light">{{
                  envasado.documentsToExpire
                }}</span>
                por vencer</span
              >
              <span
                class="badge border rounded-4 text-bg-light mx-1"
                *ngIf="hasExpiredDocuments(envasado)"
              >
                <span class="badge border rounded-circle text-bg-light">{{
                  envasado.documentsExpired
                }}</span>
                vencido</span
              >
            </td>
            <td>
              <span
                class="badge border rounded-4 text-bg-light mx-1"
                *ngFor="let blockingMotive of envasado.blockingMotives"
              >
                {{ blockingMotive }}</span
              >
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
